import React, { useState } from "react";
import Modal from "../ReusableComponents/Modal";
import { Button } from "../Components/Helper";
import SelectField from "../ReusableComponents/SelectField";
import Form from "../ReusableComponents/Form";
import Loading from "./Loader";
import Popup from "./Popup";
import DatePicker from "react-datepicker";
import { assignSubscriptionPlan } from "../apis/BhuMeetTeams/Oparations/subscriptions";
import calender from "../../src/assets/blueCalendar.svg";
import { useEffect } from "react";

const Subscription = ({ open, onClose, planDetails, dspDetails, setOpenSubModal, setPlanType, onSuccess }) => {
  const [initialValues, setInitialValues] = useState(null);
  const [formValueChanged, setFormValueChanged] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(
    dspDetails?.subscription_details
      ? {
        value: dspDetails?.subscription_details?.plan_id,
        label: dspDetails?.subscription_details?.plan_name,
        type: dspDetails?.subscription_details?.type
      }
      : { value: "", label: "", type: "trail" }
  );

  const renewablePeriods = [
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
  ];

  const [selectedRenewablePeriod, setSelectedRenewablePeriod] = useState();



  // console.log("selectedRenewablePeriod", selectedRenewablePeriod, dspDetails.subscription_details)
  const dspTypeOptions = [
    { label: "Promoted", value: "true" },
    { label: "Non Promoted", value: "false" },
  ];


  const [selectedDSPType, setSelectedDSPType] = useState(() => {
    if (dspDetails?.is_dsp_promoted === true) return dspTypeOptions[0];  // Promoted
    if (dspDetails?.is_dsp_promoted === false) return dspTypeOptions[1];   //Non Promoted
    return null;
  });

  const handleRenewablePeriod = (option) => {
    setSelectedRenewablePeriod(option);
    setPlanType(option.value);
  };

  useEffect(() => {
    if (!selectedRenewablePeriod || !planDetails) return;

     if (selectedPlan?.type === "trial") return;
    const plansForPeriod = planDetails?.filter(
      (plan) => plan?.type === selectedRenewablePeriod?.value
    );

    const matchedPlan = plansForPeriod?.find(
      (plan) =>
        plan?.name?.toLowerCase() === selectedPlan?.label?.toLowerCase()
    );

    if (matchedPlan) {
      setSelectedPlan({
        label: matchedPlan?.name,
        value: matchedPlan?.id,
        ...matchedPlan,
      });
    } else if (plansForPeriod?.length > 0) {
      // fallback to first plan (only if no match found)
      setSelectedPlan({
        label: dspDetails?.subscription_details?.plan_name,
        value: dspDetails?.subscription_details?.plan_id,
        type: dspDetails?.subscription_details?.type
      });
    }
  }, [selectedRenewablePeriod, planDetails]);




  const [dates, setDates] = useState(
    dspDetails?.subscription_details
      ? {
        startDate: new Date(dspDetails?.subscription_details?.start_date),
        endDate: new Date(dspDetails?.subscription_details?.end_date),
      }
      : { startDate: null, endDate: null }
  );

  const [openDatePicker, setOpenDatePicker] = useState({
    startDate: false,
  });


  useEffect(() => {
    if (!dates.startDate || !selectedRenewablePeriod?.value) return;

    const start = new Date(dates.startDate);

    const planDurations = {
      monthly: 30,
      quarterly: 90,
      yearly: 365,
      trial: 15,
    };

    // // Calculate days to add
    // const daysToAdd =
    //   selectedPlan?.type === "trial"
    //     ? 15
    //     : planDurations[selectedRenewablePeriod?.value?.toLowerCase()] ?? 30;

    // const end = new Date(start);
    // end.setDate(end.getDate() + daysToAdd);
      const end = new Date(start);

    if (selectedPlan?.type === "lifetime") {
      end.setFullYear(end.getFullYear() + 100); 
    } else {
      const daysToAdd = selectedPlan?.type === "trial"
        ? 15
        : planDurations[selectedRenewablePeriod?.value?.toLowerCase()] ?? 30;
      end.setDate(end.getDate() + daysToAdd); 
    }

    end.setHours(23, 59, 59, 999);

    setDates({
      startDate: start.toISOString(),
      endDate: end.toISOString(),
    });

  }, [selectedPlan, selectedRenewablePeriod, dates.startDate]);

  useEffect(() => {
    if (open) {
      setSelectedPlan(
        dspDetails?.subscription_details
          ? {
            value: dspDetails?.subscription_details?.plan_id,
            label: dspDetails?.subscription_details?.plan_name,
            type: dspDetails?.subscription_details?.type
          }
          : { value: "", label: "", type: "trial" }
      );

      setSelectedRenewablePeriod(
        dspDetails?.subscription_details
          ? renewablePeriods.find(p => p.value === dspDetails?.subscription_details?.type) || renewablePeriods[0]
          : renewablePeriods[0]
      );

      const isPromoted =
        dspDetails?.subscription_details?.is_dsp_promoted ??
        dspDetails?.is_dsp_promoted;

      setSelectedDSPType(
        isPromoted === true
          ? dspTypeOptions[0]
          : isPromoted === false
            ? dspTypeOptions[1]
            : null
      );

      setDates(
        dspDetails?.subscription_details
          ? {
            startDate: new Date(dspDetails?.subscription_details?.start_date),
            endDate: new Date(dspDetails?.subscription_details?.end_date)
          }
          : { startDate: null, endDate: null }
      );
      setInitialValues({
        plan: dspDetails?.subscription_details?.plan_name,
        period: dspDetails?.subscription_details?.type,
        dspType: Boolean(dspDetails?.is_dsp_promoted),
        startDate: dspDetails?.subscription_details?.start_date,
      });
    }
  }, [open, dspDetails]);

  useEffect(() => {
    if (dspDetails?.subscription_details) {
      const { type } = dspDetails?.subscription_details;
      const newPeriod =
        type === "trial"
          ? renewablePeriods[0]
          : renewablePeriods.find(p => p.value === type) || renewablePeriods[0];

      setSelectedRenewablePeriod(newPeriod);
    } else {
      setSelectedRenewablePeriod(renewablePeriods[0]);
    }
  }, [dspDetails]);
  const handleCreateRequest = async () => {
    try {
      const payload = {
        user_id: dspDetails?.dsp_id,
        plan_id: selectedPlan?.value,
        start_date: dates?.startDate,
        end_date: dates?.endDate,
        // type: selectedPlan?.type === "trial" ? 'trial' : selectedRenewablePeriod?.value,
         type: selectedPlan?.type === "trial" 
        ? 'trial' 
        : selectedPlan?.type === "lifetime"
            ? 'lifetime'
            : selectedRenewablePeriod?.value,
        is_dsp_promoted: selectedDSPType?.value === "true",
      }

      Loading.set(true);
      let planDetails = await assignSubscriptionPlan(payload);
      Loading.set(false)
      Popup.alert("Plan", "Plan Assigned successfully!", 'SUCCESS')
      if (onSuccess) onSuccess({ ...dspDetails, subscription_details: planDetails }, false, true);
      setOpenSubModal(false)


    } catch (err) {
      Loading.set(false)
      Popup.alert("Error", err, 'ERROR')
    }
  }

  const handleStartDateChange = (date) => {
    if (!date) return;
    const start = new Date(date);
    const now = new Date();
    start.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    setDates((prev) => ({ ...prev, startDate: start.toISOString() }));
  };


  const formatDateOnly = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  };


  useEffect(() => {
    if (!initialValues) return;

    // check if any values inside form is changed or not 
    const changed =
      selectedPlan?.name !== initialValues?.plan ||
      selectedPlan?.type !== initialValues?.period ||
      formatDateOnly(dates?.startDate) !== formatDateOnly(initialValues?.startDate) ||
      (selectedDSPType?.value === "true") !== initialValues?.dspType;

    setFormValueChanged(changed);
  }, [selectedPlan, initialValues, dates, selectedDSPType]);

  return (
    <Modal
      header={"Subscription Plans"}
      open={open}
      headerContainerStyle={{ padding: '20px 40px' }}
      onClose={onClose}
      closeOnDocumentClick={false}
      contentStyle={{ width: "750px", height: "auto" }}
    >
      <>
        <Form
          onSubmitForm={(req) => handleCreateRequest(req)}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            height: "calc(100% - 65px)",
            padding: "30px",
            gap: "20px",
            position: "relative",
            overflow: "visible",
          }}
        >
          {(onSubmit, formValue) => (
            <>
              {/* Renewable, DSP Type */}
              <div style={{
                display: "flex",
                gap: "20px",
                width: "100%",
                flexWrap: "wrap",
                zIndex: 30,
                position: "relative",
              }}>
                {/* Plan */}
                <div style={{ flex: 1, position: "relative", zIndex: 30 }}>
                  <SelectField
                    label="Choose a Plan"
                    name="subscription_plan"
                    list={planDetails}
                    value={selectedPlan}
                    handleChange={(option) => setSelectedPlan(option)}
                    validation={() => !!selectedPlan}
                    styles={{ width: "100%" }}
                    containerStyle={{ minHeight: "60px" }}
                    controlStyle={{ height: "40px" }}
                  />
                </div>

                {/* Renewable Period */}
                <div style={{ flex: 1, position: "relative", zIndex: 20 }}>
                  <SelectField
                    label="Renewable Period"
                    name="renewable_period"
                    list={renewablePeriods}
                    value={selectedRenewablePeriod}
                    handleChange={(option) => handleRenewablePeriod(option)}
                    isDisabled={!selectedPlan || selectedPlan?.type === "trial"|| selectedPlan?.type === "lifetime"}
                    validation={() => !!selectedRenewablePeriod}
                    styles={{ width: "100%" }}
                    containerStyle={{ minHeight: "60px" }}
                    controlStyle={{ height: "40px" }}
                  />
                </div>

                {/* DSP Type */}
                <div style={{ flex: 1, position: "relative", zIndex: 10 }}>
                  <SelectField
                    label="DSP Type"
                    name="dsp_type"
                    list={dspTypeOptions}
                    value={selectedDSPType}
                    handleChange={(option) => setSelectedDSPType(option)}
                    validation={() => selectedDSPType !== null}
                    styles={{ width: "100%" }}
                    containerStyle={{ minHeight: "60px" }}
                    controlStyle={{ height: "40px" }}
                    isDisabled={selectedPlan?.type === "lifetime"}
                  />
                </div>
              </div>

              {/*  Start & End Date */}
              <div
                className="date_Filters"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "15px",
                  width: "100%",
                  position: "relative",
                  marginTop: "20px",
                }}
              >
                {/* Start Date */}
                <div
                  className="input-date"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                    maxWidth: "45%",
                    height: "40px",
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "0 10px",
                    cursor: "pointer",
                    zIndex: 10
                  }}
                  onClick={() =>
                    setOpenDatePicker((prev) => ({ ...prev, startDate: true }))
                  }
                >
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    open={openDatePicker.startDate}
                    onClickOutside={() =>
                      setOpenDatePicker((prev) => ({ ...prev, startDate: false }))
                    }
                    placeholderText="Start Date"
                    readOnly
                    selected={dates.startDate ? new Date(dates.startDate) : null}
                    onChange={handleStartDateChange}
                    popperPlacement="bottom-start"
                    popperClassName="custom-datepicker-popper"
                  />
                  <img
                    src={calender}
                    alt="calendar"
                    style={{ width: "18px", position: "absolute", right: "10px" }}
                  />
                </div>

                <span style={{ fontSize: "18px", color: "#555" }}>–</span>

                {/* End Date */}
                <div
                  className="input-date"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                    maxWidth: "45%",
                    height: "40px",
                    background: "#f7f7f7",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "0 10px",
                    zIndex: 10,
                    opacity: selectedPlan?.type === "trial" ? 0.6 : 1
                  }}
                >
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    placeholderText="End Date"
                    readOnly
                    selected={dates.endDate ? new Date(dates.endDate) : null}
                    popperPlacement="bottom-start"
                    popperClassName="custom-datepicker-popper"
                    isDisabled={selectedPlan?.type === "trial"}
                  />
                  <img
                    src={calender}
                    alt="calendar"
                    style={{ width: "18px", position: "absolute", right: "10px" }}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  padding: "28px 0px 20px 122px",
                }}
              >
                <Button
                  text={dspDetails?.subscription_details ? "Modify" : "Add"}
                  className={"btn-large"}
                  type={"Save"}
                  isDisabled={!formValueChanged || !dates.startDate || !dates.endDate}
                  onClick={onSubmit}
                  style={{
                    width: "141px",
                    height: "47px",
                    fontSize: "16px",
                  }}
                />
              </div>
            </>
          )}
        </Form>
      </>
    </Modal>

  );
};

export default Subscription;
